import * as Sentry from '@sentry/react';
import { useQuery } from '@tanstack/react-query';
import toast from 'react-hot-toast';
import { generatePredictiveInsightsForBusiness } from 'api/admin/businesses/generatePredictiveInsightsForBusiness';
import { ApiError } from 'types/api';

interface GeneratePredictiveInsightsPayload {
    businessId: number;
    dataSharingConsentDate: string | null;
    isDataSharingConsented: boolean;
    enabled: boolean;
}

interface UseGeneratePredictiveInsightsForBusinessOutput {
  success: boolean;
}

export const useGeneratePredictiveInsightsForBusiness = ({
    businessId,
    dataSharingConsentDate,
    isDataSharingConsented,
    enabled = true,
  }: GeneratePredictiveInsightsPayload) => {
    return useQuery<unknown, ApiError, UseGeneratePredictiveInsightsForBusinessOutput>({
      queryKey: ['generatePredictiveInsightsForBusiness', { businessId }],
      queryFn: async () => {
        if (!businessId || !dataSharingConsentDate || !isDataSharingConsented) {
          return {
            success: false,
          };
        }
  
        const { data } = await generatePredictiveInsightsForBusiness(businessId);

        if (data.success) {
          toast('Predictive insights have been generated - reach out to Ethan to see the results!', {
            icon: '✅',
          });
        }
  
        return data;
      },
      onError: (error) => {
        Sentry.captureException(error);
        toast.error(
          error?.response?.data?.error ?? 'An error occurred while generating predictive insights for the given business',
          {
            duration: 4000,
          },
        );
        return error;
      },
      enabled,
    });
  };
